export class NezadouciSlovo {
    id: number;

    slovo: string;
}